import { useState } from "react";
import { Row, Col, Typography, Table, Form, Input } from 'antd';
import Button from "@/components/ui/Button";
import styled from "styled-components";
import { useEffect } from "react";
import api from "@/utils/api"
import { notification } from "antd";
import { API_URL } from "../../constants";
const { Title, Text } = Typography
const SettingsWrapper = styled.div`
  margin: 20px;
  button {
    background-color: var(--primary-main-color);
    color: white;
  }
  .settings-form{
    margin-top: 20px;
    max-width: 400px;
  }
  .save-button{
  }
  .ant-form-item-control{
    margin-left: 8px;
  }
  .ant-input {
    border-radius: 8px;
  }
`
const StyledTable = styled(Table)`
  .ant-table-head {
    background: #fafafa;
  }
  .ant-table-thead > tr > th {
    font-size: 12px;
    color: #909090;
    font-weight: 400;
    border-bottom: 0;
  }

  .ant-table-tbody {
    border-radius: 10px;
    overflow: hidden;
    background: white;
  }
`;
const columns = [
    {
        width: "100px",
        title: "Name",
        render(data) {
            return data?.name;
        },
    },
    {
        width: "300px",
        title: "Description",
        render(data) {
            return data?.description;
        }
    }
]

const metadataColumns = [
    {
        width: "100px",
        title: "Name",
        render(data) {
            return data?.name;
        },
    },
    {
        width: "300px",
        title: "Value",
        render(data) {
            return data?.value;
        }
    }
]

async function fetchShop(shopName) {

    try {
        const shop = await api.get(`${API_URL}/get-shop/?shop=${shopName}`)
        console.log(shop)
        return true
    } catch (error) {
        notification.error({
            message: error,
        });
        return false
    }
}

export function Settings({ settings, onSave }) {
    const [showMetadata, setShowMetadata] = useState(false)
    useEffect(() => {
        console.log('Settings are', settings);
        const queryParams = new URLSearchParams(window.location.search);
        const showMetadata = queryParams.get('show-metadata');
        if (showMetadata && showMetadata === "true") {
            setShowMetadata(true)
        } else {
            setShowMetadata(false)
        }
        console.log(showMetadata)
    }, [])
    const shortcodes = [{
        name: 'mragain_shortcode_appointment',
        description: 'Appointment shortcode.',
    },
    {
        name: 'mragain_shortcode_model_inline_search',
        description: 'Models inline search. Parameters: width (e.g. 400), redirect_url (e.g. http://<wp_site>/mragain-appointments).'
    }]

    const metadata = [{
        name: 'Name',
        value: process.env.REACT_APP_PLUGIN_NAME || 'MrAgain Plugin',
    },
    {
        name: 'Version',
        value: process.env.REACT_APP_PLUGIN_VERSION || '1.0.dev',
    },
    {
        name: 'Build Number',
        value: process.env.REACT_APP_BUILD_NUMBER || '',
    },
    {
        name: 'API URL',
        value: process.env.REACT_APP_API_URL,
    },

    ]
    const onFinish = (values) => {
        console.log(settings)
        async function save() {
            const res = await fetchShop(values.shopName);
            if (res) {
                onSave(values)
            }
        }
        save()
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    const formLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 15 },
    };
    const initialValues = {
        shopName: settings.shopName,
        primaryMainColor: settings.primaryMainColor || "#06C987",
        primaryLightColor: settings.primaryLightColor || "#AEDECE"
    }
    return (
        <SettingsWrapper>
            <Row type="flex" gutter={32} >
                {showMetadata && <Col span={24} className='shortcodes'>
                    <Title>Plugin Metadata</Title>
                    <StyledTable columns={metadataColumns} dataSource={metadata} pagination={false} />
                </Col>

                }
                <Col span={24} className='shortcodes'>
                    <Title>Plugin Shortcodes</Title>
                    <StyledTable columns={columns} dataSource={shortcodes} pagination={false} />
                </Col>
                <Col span={24} className='settings-form'>
                    <Title>Plugin Instellingen</Title>
                    <Form
                        name="settings"
                        initialValues={initialValues}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            {...formLayout}
                            label="MrAgain shop-naam"
                            name="shopName"
                            rules={[{ required: true, message: 'Vul je shopnaam op MrAgain in.' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            {...formLayout}
                            label="Primaire kleur"
                            name="primaryMainColor"
                        >
                            <Input />
                            {/* <Text type="secondary">Set the primary main color. Default: #06C987</Text> */}
                        </Form.Item>

                        <Form.Item
                            {...formLayout}
                            label="Primary lichte kleur"
                            name="primaryLightColor"
                        >
                            <Input />
                            {/* <Text type="secondary">Set the primary main color. Default: #AEDECE</Text> */}
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" shape="round" className="save-button" >
                                Opslaan
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>

        </SettingsWrapper>
    );
};
